import React from "react";
import "./Sections.css";
import ShakingText from "./ShakingText";
import {SectionProps} from "./Section";
import BoxEffect from "./BoxEffect";
const ConceptSection:React.FC<SectionProps> = (props) => {
    return (
    <div className={"SectionBase Concept"}>
        <div className={"SectionContent Concept"}>
            <ShakingText text={"ことばとかたちエンジニアリング"}/>
        </div>
    </div>
    )
};

export default ConceptSection;